import { createLink } from '@tanstack/react-router';
import { ComponentType, ReactNode } from 'react';
import { BreadcrumbItem, breadcrumbsFactory, DropdownItemProps } from '@optimus-web/core';
import { DropdownItemLink } from '../../link/DropdownItemLink';

export interface Breadcrumb {
    title: ReactNode;
    path: string;
}

export interface BreadcrumbsProps {
    breadcrumbs: Breadcrumb[];
}

const BreadcrumbItemLink = createLink(BreadcrumbItem);

const OptimusBreadcrumbs = breadcrumbsFactory({
    DropdownItemComponent: DropdownItemLink as ComponentType<DropdownItemProps>,
});

export const Breadcrumbs = ({ breadcrumbs, ...other }: BreadcrumbsProps) => (
    <OptimusBreadcrumbs {...other}>
        {breadcrumbs.map(({ path, title }) => (
            <BreadcrumbItemLink key={`breadcrumb.${path}`} to={path} activeOptions={{ exact: true }}>
                {title}
            </BreadcrumbItemLink>
        ))}
    </OptimusBreadcrumbs>
);
